var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Label, Text, Title } from "../../tremor/Text";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import React, { memo, useEffect, useMemo, useState } from "react";
import { useBackend } from "../../layouts/Wrapper";
import { useDashboard } from "../../layouts/Dashboard/useDashboard";
import { DropdownMenuGroup, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator } from "../../tremor/DropdownMenu";
dayjs.extend(relativeTime);
function groupTextsByTime(entries) {
    const groups = {};
    entries.forEach((entry) => {
        const groupKey = `${dayjs(entry.created_at).fromNow(true)}`;
        if (!groups[groupKey]) {
            groups[groupKey] = [];
        }
        groups[groupKey].push(entry);
    });
    const sortedKeys = Object.keys(groups).sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
    return sortedKeys.reduce((acc, key) => {
        acc[key] = groups[key];
        return acc;
    }, {});
}
const QuestionHistoryRaw = ({ onSelect, variant, limit }) => {
    const { backend } = useBackend();
    const { dashboard } = useDashboard();
    const [loading, setLoading] = useState(true);
    const [questions, setQuestions] = useState([]);
    const getQuestions = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        if (!backend || !dashboard)
            return;
        let qs = yield backend.questions.list({ dashboard: dashboard.id });
        let sorted = qs.sort((a, b) => {
            return (new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
        });
        setQuestions(sorted);
        setLoading(false);
    });
    useEffect(() => {
        if (dashboard && dashboard.id) {
            getQuestions();
        }
    }, [dashboard === null || dashboard === void 0 ? void 0 : dashboard.id]);
    const filtered = useMemo(() => {
        if (!limit)
            return questions;
        return questions.slice(0, limit);
    }, [questions, limit]);
    if (!loading && questions.length === 0) {
        return React.createElement(React.Fragment, null);
    }
    if (variant === "dropdown") {
        const grouped = groupTextsByTime(filtered);
        return (React.createElement(React.Fragment, null, Object.entries(grouped).map(([key, value]) => {
            return (React.createElement(React.Fragment, null,
                React.createElement(DropdownMenuLabel, null, key),
                React.createElement(DropdownMenuGroup, null, value.map((a) => {
                    let truncated = a.query.slice(0, 60) + "...";
                    return (React.createElement(DropdownMenuItem, { key: a.id, onClick: () => onSelect(a) },
                        React.createElement("span", { className: "onvo-flex onvo-items-center onvo-gap-x-2" },
                            React.createElement("span", null, truncated))));
                })),
                React.createElement(DropdownMenuSeparator, null)));
        })));
    }
    return (React.createElement("div", { className: "onvo-w-full onvo-flex onvo-flex-col onvo-h-full onvo-justify-end" },
        React.createElement("div", { className: "onvo-flex onvo-w-full onvo-p-2 onvo-flex-row onvo-items-center onvo-justify-between" },
            React.createElement(Title, null, "History")),
        React.createElement("div", { className: "onvo-w-full onvo-grid onvo-gap-0 onvo-grid-cols-1" },
            loading &&
                [1, 2, 3, 4].map((a) => (React.createElement("div", { key: "question-history-loader-" + a, className: "onvo-transition-all onvo-group onvo-relative onvo-flex onvo-flex-col onvo-w-full onvo-px-2 onvo-py-2 onvo-rounded-2xl" },
                    React.createElement("div", { className: "onvo-flex-grow onvo-flex onvo-flex-row onvo-justify-between onvo-cursor-pointer onvo-items-center onvo-gap-4" },
                        React.createElement("div", { className: "onvo-flex-grow onvo-w-full onvo-flex onvo-flex-col onvo-gap-1" },
                            React.createElement("div", { className: "onvo-h-3 onvo-bg-slate-200 onvo-rounded-md dark:onvo-bg-slate-700 onvo-w-full onvo-flex-grow" }),
                            React.createElement("div", { className: "onvo-h-3 onvo-bg-slate-200 onvo-rounded-md dark:onvo-bg-slate-700 onvo-w-[60%] onvo-flex-grow" })),
                        React.createElement("div", { className: "onvo-w-16 onvo-h-3 onvo-bg-slate-200 onvo-rounded-md dark:onvo-bg-slate-700" }))))),
            filtered.map((a) => {
                let truncated = a.query.slice(0, 240) + "...";
                return (React.createElement("div", { className: "onvo-transition-all onvo-group onvo-relative onvo-flex onvo-w-full onvo-px-2 onvo-py-2 hover:onvo-bg-black/5 hover:onvo-dark:bg-white/10 onvo-rounded-lg" },
                    React.createElement("div", { className: "onvo-flex-grow onvo-flex onvo-flex-row onvo-justify-between onvo-cursor-pointer onvo-items-center onvo-gap-4", onClick: () => onSelect(a) },
                        React.createElement(Text, { className: "onvo-text-md" }, truncated),
                        React.createElement(Label, { className: "onvo-font-semibold onvo-text-xs onvo-w-16 onvo-flex-shrink-0 onvo-text-right" }, dayjs(a.created_at).fromNow(true)))));
            }))));
};
export const QuestionHistory = memo(QuestionHistoryRaw);
//# sourceMappingURL=QuestionHistory.js.map